import store from '@/store/index';

export const hasUserpref = {
  hasUserPreference: (key: string, valeur: string) => {
    var userPreference = store.state.user.user_preferences.find((value: any) => { return value.key == key})
    return userPreference?.value?.indexOf(valeur) !== -1
  }
}